// extracted by mini-css-extract-plugin
export var banner = "_2m-0";
export var icon = "_2m-1";
export var message = "_2m-2";